const getQueryParams = (params) => {
  let paramsURL = "";
  for (let param in params) {
    paramsURL += `filter[${param}]=${params[param]}&`;
  }
  return paramsURL;
};

// params used for as filters for backend requests
const addParamToURL = (paramName, paramValue, $this) => {
  let newParam = {};
  paramValue !== "all"
    ? (newParam = { [paramName]: paramValue })
    : (newParam = { [paramName]: "" });
  const currentParams = $this.$route.query;
  return $this.$router.push({ query: { ...currentParams, ...newParam } });
};

export { getQueryParams, addParamToURL };
